import 'select2';
import 'select2/dist/css/select2';
import PersonService from '../entrypoints/src/admin/services/person-service.js';
import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    // Per-session cache of results keyed by the search term. The custom Select2
    // `transport` below bypasses Select2's built-in ajax caching, so we memoize here
    // to avoid re-hitting PeopleController when the user backspaces/retypes the same term.
    this.searchCache = new Map();

    this.bindingSelect2();

    $('.search-nav-people').find('.select2').removeClass('select2').addClass('select2-nav-search')
  }

  disconnect() {
    this.searchCache?.clear();
  }

  bindingSelect2() {
    $('#select2-search-nav-people')
      .select2({
        placeholder: 'Buscar Pessoa',
        allowClear: true,
        dropdownParent: document.querySelector('#search-nav-people-wrapper'),
        minimumInputLength: 4,
        escapeMarkup: (markup) => markup,
        templateResult: this.formatAvatar,
        templateSelection: (person) => {
          if (!person || !person.id) return 'Buscar Pessoa';

          return `<span><span class="font-capitalize">${person.text.toLowerCase()}</span></span>`;
        },
        language: {
          inputTooShort: () => 'Por favor, insira 4 ou mais caracteres',
          searching: () => 'Buscando...',
          noResults: () => 'Nenhum resultado encontrado'
        },
        ajax: {
          transport: (params, success, failure) => this.searchPeople(params.data.term, success, failure),
          processResults: (data) => {
            return {
              results: data.results
            };
          },
          delay: 250
        }
      })
      .on('select2:select', (e) => {
        window.location.assign(e.params.data.url);
      });
  }

  async searchPeople(term, success, failure) {
    const key = (term || '').trim().toLowerCase();

    if (this.searchCache.has(key)) {
      success({ results: this.searchCache.get(key) });
      return;
    }

    try {
      const people = await PersonService.findBy({ query: term });
      const results = people.map((i) => {
        return { id: i.id, text: i.name.toUpperCase(), type: i.type, guardian: i.guardian, url: i.url, avatar: i.avatar };
      });

      this.searchCache.set(key, results);
      success({ results });
    } catch (error) {
      console.error("Erro ao buscar pessoas:", error);
      failure();
    }
  }

  formatAvatar(person) {
    if (!person || !person.id) return 'Buscar Pessoa';

    return `<div>
      <div class="flex items-center gap-2">
        <div class="w-8 h-8 inline-flex justify-center border rounded-full relative">
          ${person.avatar ? `<img src="${person.avatar}" class="w-100 h-auto rounded-full" alt="Profile photo" >` :
            `<div class="w-[70%] inline-flex items-center content-center m-1">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
            </div>`}
        </div>
        <div class="capitalize">${person.text.toLowerCase()}</div>
      </div>
      <div class="inline-block text-xs rounded-full px-2 bg-zinc-100">${person.guardian ? 'responsável' : person.type}</div>
    </div>`;
  }
}